/**
 * Sorts an array of value-label objects by the value property.
 *
 * @param array - The array of value-label objects to be sorted.
 * @param order - The order in which to sort the array. Can be 'ascending', 'descending', or 'definition order'.
 * @returns The sorted array of value-label objects.
 */
function sortValueLabelArrayByLabel(
    array: { value: string; label: string }[],
    order: "ascending" | "descending" | "definition order" = "definition order",
) {
    return array.sort((a, b) => {
        if (a.label === undefined || b.label === undefined) {
            return 0;
        }
        if (order === "ascending") {
            return a.label.localeCompare(b.label);
        }
        if (order === "descending") {
            return b.label.localeCompare(a.label);
        }
        return 0;
    });
}

function validateEmail(value: string, blacklistDomains?: string[]) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value)) {
        return {
            status: "error",
            error: "Please enter a valid email address.",
        };
    }

    if (blacklistDomains) {
        const domain = value.split("@")[1];
        if (blacklistDomains.includes(domain)) {
            return {
                status: "error",
                error: "This email domain is not allowed.",
            };
        }
    }

    return {
        status: "success",
    };
}

export { sortValueLabelArrayByLabel, validateEmail };
